(function ($, Drupal) {
  // Placeholder for saving the user's place when closing the mobile navigation.
  let focusedNavEl = null;

  /**
   * Toggle mobile navigation.
   */
  Drupal.behaviors.mobileNavToggle = {
    attach: function (context, settings) {
      // Some unknown Drupal JS is causing our click event to trigger multiple times,
      // so we add .off() here.
      $(".menu-toggle")
        .off()
        .on("click.mobileNav tap.mobileNav touch.mobileNav", function () {
          $(this).toggleClass("active");
          $(".mobile-navigation").toggleClass("active");
          $(".mobile-navigation").removeAttr("inert");
          $("body").toggleClass("fixed");
          $(".region-header-top").toggleClass("hidden");
          if ($(this).attr("aria-expanded") == "false") {
            // Change is here.
            $(this).attr("aria-expanded", "true");
          } else {
            $(this).attr("aria-expanded", "false");
          }
          if (focusedNavEl) {
            focusedNavEl.focus();
          }
        });
    },
  };

  Drupal.behaviors.alkamiForm = {
    attach: function (context, settings) {
      $(".alkami-form-short", context).appendTo(".site-header");
      $(".open-form", context)
        .off()
        .on("click", function () {
          $(".alkami-form-short", context).toggleClass("visible");
        });

      $(".alkami-form-short #close-form", context)
        .off()
        .on("click", function () {
          $(".alkami-form-short", context).removeClass("visible");
          $(".path-frontpage .alkami-form-short", context).css(
            "display",
            "none"
          );

          sessionStorage.closeform = true;
        });

      $(document).mouseup(function (e) {
        var form = $(".alkami-form-short");
        var formButton = $(".open-form");

        // If the target of the click isn't the container
        if (
          !form.is(e.target) &&
          !formButton.is(e.target) &&
          form.has(e.target).length === 0
        ) {
          form.removeClass("visible");
        }
      });

      const togglePassword = document.getElementById("showPassword");
      const password = document.getElementById("password");

      if (togglePassword) {
        togglePassword.addEventListener("click", function (e) {
          // toggle the type attribute
          const type =
            password.getAttribute("type") === "password" ? "text" : "password";
          password.setAttribute("type", type);
        });
      }

      const rmCheck = document.getElementById("rememberMe"),
        usernameInput = document.getElementById("username"),
        passwordInput = document.getElementById("password");

      if (localStorage.checkbox && localStorage.checkbox !== "") {
        rmCheck.setAttribute("checked", "checked");
        usernameInput.value = localStorage.username;
        passwordInput.value = localStorage.password;
      } else {
        rmCheck.removeAttribute("checked");
        usernameInput.value = "";
        passwordInput.value = "";
      }

      if (
        rmCheck.checked &&
        usernameInput.value !== "" &&
        passwordInput.value !== ""
      ) {
        localStorage.username = usernameInput.value;
        localStorage.password = passwordInput.value;
        localStorage.checkbox = rmCheck.value;
      } else {
        localStorage.username = "";
        localStorage.password = "";
        localStorage.checkbox = "";
      }
    },
  };

  Drupal.behaviors.passwordVisibility = {
    attach: function (context, settings) {
      $(once("password-visibility", 'input[name="password"]', context)).each(
        function () {
          const passwordInput = $(this);
          const loginWrapper = document.createElement("span");
          const visibilityButton = document.createElement("button");
          const eyeIcon =
            '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#004c6d" stroke-width="1.5" stroke-linecap="round" stroke-linjoin="round" aria-hidden="true">' +
            '<path class="eye-open" d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>' +
            '<circle class="eye-open" cx="12" cy="12" r="3"></circle>' +
            '<line class="eye-closed" x1="4" y1="4" x2="20" y2="20" style="display: none"></line>' +
            '<path class="eye-closed" d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" style="display: none"></path>' +
            '<path class="eye-closed" d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" style="display: none"></path>' +
            "</svg>";

          loginWrapper.classList.add("password-toggle-wrapper");
          visibilityButton.classList.add("password-visibility-btn");
          visibilityButton.setAttribute("type", "button"),
            visibilityButton.setAttribute("aria-label", "Show password");
          visibilityButton.setAttribute("aria-pressed", "false");
          visibilityButton.innerHTML = eyeIcon;

          passwordInput.wrap(loginWrapper);
          passwordInput.after(visibilityButton);
          passwordInput.closest(".password-toggle-wrapper").css({
            position: "relative",
            display: "inline-block",
            width: "100%",
          });

          $(visibilityButton).on("click", function () {
            const isPassword = $(passwordInput).attr("type") === "password";
            $(passwordInput).attr("type", isPassword ? "text" : "password");
            $(this).attr("aria-pressed", isPassword ? "true" : "false");
            $(visibilityButton).find(".eye-open").toggle(!isPassword);
            $(visibilityButton).find(".eye-closed").toggle(isPassword);
          });
        }
      );
    },
  };

  // shorthand for document ready
  $(function () {
    if ($(window).width() >= 1200) {
      if (sessionStorage.closeform) {
        $(".path-frontpage .alkami-form-short").css("display", "none");
      } else {
        $(".path-frontpage .alkami-form-short")
          .css("display", "block")
          .css("opacity", "1")
          .css("position", "relative");
      }
    } else {
      $(".path-frontpage .alkami-form-short").css("display", "none");
    }

    $(".menu--main .nolink").attr("role", "button");

    /**
     *  Mobile navigation.
     */
    function mobileNav() {
      const subMenu = $(".menu--main .menu-level-1 > .menu-item"),
        headerRightBottom = $(".header__right-bottom"),
        headerCenter = $(".header__center");

      headerCenter.addClass("mobile-navigation").removeClass("desktop-nav");

      $(".path-frontpage .alkami-form-short")
        .css("display", "none")
        .removeClass("visible");

      if ($("#block-civiccu-searchtoggle").length) {
        $(".header__left").append($("#block-civiccu-searchtoggle"));
      }

      // add only once
      if (!$(".menu--main .menu-level-0 > li span .nav-arrow").length) {
        $(".menu--main .menu-level-0 > li > span").append(
          '<span class="nav-arrow"></span>'
        );
      }

      $(".menu--main .nolink").attr("tabindex", "0");
      $(".menu--main .nolink").each((index, buttonSpan) => {
        let targetDiv = buttonSpan.nextSibling;
        while (targetDiv && targetDiv.nodeType !== 1) {
          targetDiv = targetDiv.nextSibling;
        }
        if ($(targetDiv).hasClass("active")) {
          buttonSpan.setAttribute("aria-expanded", "true");
        } else {
          buttonSpan.setAttribute("aria-expanded", "false");
        }
      });

      // Remove style if user resizes from an open desktop nav
      $(".menu--main .menu-dropdown-0").removeAttr("style");
      $(".menu--main .menu-dropdown-0 a").attr("tabindex", "-1");

      // Remove desktop event listener
      $(".header__right").off();
      $(".header__right a").attr("tabindex", "0");

      $(".menu--main .nolink")
        .off("click keydown")
        .on("click keydown", function (e) {
          if (e.type === "click" || e.key === "Enter" || e.key === " ") {
            const nextParentSibling = $(this)
              .closest(".menu-item")
              .next(".menu-item")
              .find("span")
              .first();
            const activeLi = $(this).closest(".menu-item");
            const activeLiDiv = activeLi.find("div").first();
            const activeMenu = activeLi.find(".menu").first();
            const extraLinks = activeMenu
              .children(".menu-item:nth-last-child(2)")
              .find("a");

            let backLink = activeLiDiv.find(".back");

            $(this).attr("aria-expanded", "true");

            // Move login block to submenu
            activeLiDiv.append($(".header__right"));

            // Re-enable menu if disabled
            activeMenu[0].inert = false;

            Object.keys(extraLinks).forEach((key) => {
              if (extraLinks.hasOwnProperty(key) && !isNaN(key)) {
                extraLinks[key].tabIndex = "0";
              }
            });

            e.key === " " ? e.preventDefault() : null;
            let $trigger = $(this);
            let $li = $trigger.closest("li.menu-item");

            // Find the label element inside the same <li>
            let backText = $li
              .children("a.nolink, span.nolink")
              .first()
              .text()
              .trim();

            // Fallback if no nolink found: maybe a regular <span> was used
            if (!backText) {
              backText = $li
                .children("span")
                .not(".nav-arrow")
                .first()
                .text()
                .trim();
            }

            headerCenter.scrollTop(0);
            $(".menu--main .menu-dropdown-0").removeClass("active");
            $(this).nextAll(".menu--main .menu-dropdown-0").addClass("active");

            // Add backLink only once
            if (backLink.length === 0) {
              backLink = document.createElement("span");
              const backArrow = document.createElement("span");

              backArrow.className = "nav-arrow";
              backLink.className = "back";
              backLink.setAttribute("role", "button");
              backLink.setAttribute("tabindex", "0");
              backLink.setAttribute("aria-label", "Go back");
              backLink.textContent = backText;
              backLink.prepend(backArrow);

              activeLiDiv.prepend(backLink);
            }

            headerCenter.addClass("sub-active");

            $(backLink).on("click keydown", function (e) {
              if (e.type === "click" || e.key === "Enter" || e.key === " ") {
                closeSubMenu();
                $(activeLi).find("span").first().focus();
              }
              // Close submenu if user backs out instead of clicking .back
              else if (e.key == "Tab" && e.shiftKey) {
                closeSubMenu();
              }
            });

            // Scroll into view in case expanded submenus push
            // down the active element
            if (document.activeElement == $(this)) {
              $(this).scrollIntoView({ behavior: "smooth" });
            }

            // Close submenu when user tabs out to next parent menu item
            $(nextParentSibling).on("focusin", function () {
              closeSubMenu();
            });

            focusBackLink();

            function focusBackLink() {
              if (document.activeElement != $(activeLiDiv).find(".back")[0]) {
                // Make sure back link is fully rendered before focusing
                setTimeout(() => {
                  $(activeLiDiv).find(".back")[0].focus();
                  focusBackLink();
                }, 1);
              }
            }

            function closeSubMenu() {
              activeLi.find("span").first().attr("aria-expanded", "false");
              activeLiDiv.removeClass("active");

              // Disable submenu to prevent interaction
              activeMenu[0].inert = true;
              headerRightBottom.removeClass("fixed");
              headerCenter.removeClass("sub-active");
              $(backLink).remove();

              // Move login block back to its original region
              $(".header__center").append($(".header__right"));
            }
          }
        });

      subMenu.each(function () {
        const menuSpan = $(this).find("span").first();
        menuSpan.attr("tabindex", "0");
        if (!menuSpan[0].querySelector(".toggle-sub")) {
          const toggleSub = document.createElement("span");
          toggleSub.className = "toggle-sub";
          menuSpan.append(toggleSub);
        }
        menuSpan.attr("role", "button");
        menuSpan.attr("aria-expanded", "false");
        menuSpan.off().on("click keydown", function (e) {
          if (e.type === "click" || e.key === "Enter" || e.key === " ") {
            // Prevent scrolling when space is pressed
            e.key === " " ? e.preventDefault() : null;
            const dropdownMenu = $(this).next(".menu-dropdown")["0"];
            $(dropdownMenu).find("a").attr("tabindex", "0");
            $(this).parent().toggleClass("active");
            if ($(this).parent().hasClass("active")) {
              $(this).attr("aria-expanded", "true");
            } else {
              $(this).attr("aria-expanded", "false");
            }
            e.stopPropagation();
          }
        });
      });

      $(document)
        // .off("keydown")
        .on("keydown", function (e) {
          // close search and/or dropdown on escape
          if (e.key === "Escape") {
            if ($(".ais-search__container").hasClass("active")) {
              $(".ais-search__container").removeClass("active");
              toggleSearchEl.focus();
            } else if ($(".header__center").hasClass("active")) {
              focusedNavEl = document.activeElement;

              $(".menu-toggle")
                .removeClass("active")
                .attr("aria-expanded", "false")
                .focus();
              $(".mobile-navigation").removeClass("active");
              $("body").removeClass("fixed");
              $(".region-header-top").removeClass("hidden");
              $(".menu-toggle").attr("aria-expanded", "false");
              $(".menu--main .nav-arrow,.menu--main .nolink").removeClass(
                "active"
              );
              $(".mobile-navigation").attr("inert", "");
              $(".header__center").append($(".header__right"));
            }
          }
        });

      $(".header__center")
        .off()
        .on("focusout", function (e) {
          // Close menu when focus moves outside of mobile nav container
          if (
            !$(".header__center")[0].contains(e.relatedTarget) &&
            e.relatedTarget !== null
          ) {
            $(".header__center").removeClass("active");
            $(".menu-toggle")
              .removeClass("active")
              .attr("aria-expanded", "false");
            $("body").removeClass("fixed");
            $(".region-header-top").removeClass("hidden");
            $(".header__center").append($(".header__right"));
          }
        });
    }

    function searchInput() {
      $(".ais-SearchBox-input").on("keyup", function () {
        var value = $(this).val();
        if (value.length == 0) {
          //if words are typed
          $(".search-quicklinks").show();
        } else {
          $(".search-quicklinks").hide();
          $("body").addClass("search-active");
        }

        if ($(".block-alertbox").length > 0) {
          $(".main-content").css();
        }
      });
    }

    let toggleSearchEl = $("#toggle-search");

    function toggleSearch() {
      toggleSearchEl.on("click", function (event) {
        event.preventDefault();
        $(".ais-search__container")
          .addClass("active")
          .find(".ais-SearchBox-input")
          .focus();
        var mainContentHeight = $(".main-content").height();

        if ($(document).width() < 1200) {
          var searchResultsHeight = mainContentHeight - 110;
        } else {
          var searchResultsHeight = mainContentHeight - 130;
        }

        event.stopPropagation();
      });

      $(document).on("click", function (event) {
        var searchContainer = $(".ais-search__container");

        if (
          searchContainer.hasClass("active") &&
          !$(event.target).closest(
            ".ais-search__container, " + toggleSearchEl.selector
          ).length
        ) {
          searchContainer.removeClass("active");
        }
      });
    }

    function searchClear() {
      $(".search-clear").on("click", function () {
        $(".ais-search__container").removeClass("active");
        $("body").removeClass("search-active");
        toggleSearchEl.focus();
      });
    }

    function resetDropdown() {
      $(".menu > li").removeClass("open");
    }

    function desktopNav() {
      $(".menu-dropdown-0").removeClass("active");
      $(".menu-item").removeClass("active");
      $(".header__right-bottom").removeClass("fixed");
      $(".header__center").removeClass("sub-active");
      $(".header__center").removeAttr("inert");

      // Remove inert from submenu rendered inert by mobile navigation
      $(".menu-level-1").removeAttr("inert");
      $("span.back").remove();

      // Remove role and aria-expanded attributes from menu items if user resizes from mobile to desktop
      $(".menu-level-1 .menu-item > span").removeAttr("role");
      $(".menu-level-1 .menu-item > span").removeAttr("aria-expanded");

      // move search back
      if ($("#block-civiccu-searchtoggle").length) {
        $(".region-header-bottom-right").prepend(
          $("#block-civiccu-searchtoggle")
        );
      }

      // Move header right back to its original region
      $(".header__center").append($(".header__right"));

      $(".header__center")
        .removeClass("mobile-navigation")
        .addClass("desktop-nav");

      $(document)
        // .off()
        .on("keydown", function (e) {
          // close dropdown on escape
          if (e.key === "Escape") {
            $(".menu-dropdown-0").removeAttr("style");
            $(".menu-dropdown-0 ul a").attr("tabindex", "-1");
            $(".menu--main > ul > li > span.nolink").attr(
              "aria-expanded",
              "false"
            );
          }
        });

      // prevent from getting focus
      $(".menu-level-1 .menu-item > span").removeAttr("tabindex");

      // reset some mobile nav settings if resized when menu active
      $(".mobile-navigation").removeClass("active");
      $("body").removeClass("fixed");
      $(".menu .nolink").attr("tabindex", "0");
      $(".menu-toggle").removeClass("active");
      // allow nolink to get focus
      $(".desktop-nav .menu .nolink").attr("tabindex", "0");

      // prevent focus on hidden dropdown links
      $(".desktop-nav .menu-dropdown-0 ul a").attr("tabindex", "-1");

      const desktopNavButtons = $(".desktop-nav .menu span.nolink");

      desktopNavButtons.attr("tabindex", "0");
      desktopNavButtons.attr("aria-expanded", "false");
      desktopNavButtons.off().on("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();

          const dropdownUL = $(this).next(".menu-dropdown-0");
          const isVisible = dropdownUL.css("visibility") === "visible";

          $(".desktop-nav .menu-dropdown-0").removeAttr("style");
          $(".desktop-nav .menu-dropdown-0 a").attr("tabindex", "-1");
          if (!isVisible) {
            dropdownUL.css({
              visibility: "visible",
              opacity: 1,
              transform: "translateX(-50%)",
            });
            $(this).attr("aria-expanded", "true");
            dropdownUL.find("a").attr("tabindex", "0");
          } else {
            $(this).attr("aria-expanded", "false");
          }
        }
      });

      // set to keyup in case user holds key down too long
      $(".desktop-nav .nolink, a.site-logo").on("keyup", function (e) {
        var whatIntent = $("html").data("whatintent");
        if (e.key == "Enter" && whatIntent == "keyboard") {
          // enter key + keyboard
          $(this).parent().toggleClass("open");
        }

        if (e.key == "Tab" && whatIntent == "keyboard") {
          // tab + keyboard
          resetDropdown();
        }
      });

      $(".desktop-nav .menu > li > a:only-child").on("keyup", function (e) {
        var whatIntent = $("html").data("whatintent");
        if (e.key == "Tab" && whatIntent == "keyboard") {
          // tab + keyboard
          resetDropdown();
        }
      });

      $(".header__center")
        .off()
        .on("focusout", function (e) {
          // Close menu when focus moves outside of header center
          if (
            !$(".header__center")[0].contains(e.relatedTarget) &&
            e.relatedTarget !== null
          ) {
            $(".menu-dropdown-0").removeAttr("style");
            $(".menu-dropdown-0 a").attr("tabindex", "-1");
          }
        });

      $(".header__right")
        .off()
        .on("focusin", function (e) {
          // Close menu when focus moves to header right
          $(".menu-dropdown-0").removeAttr("style");
          $(".menu-dropdown-0 a").attr("tabindex", "-1");
        });
    }

    function mapSection() {
      if ($("#wave2locator").length) {
        $("#wave2locator").closest("section").addClass("locations-map");
      }
    }

    function toggleDmbNotification() {
      $(".toggle-dmb-notification").on(
        "click.mobileNav tap.mobileNav touch.mobileNav",
        function () {
          if ($(this).parent().hasClass("active")) {
            $(this).parent().removeClass("active");
            $(this).attr({
              "aria-expanded": "false",
              "aria-label": Drupal.t("Expand notification"),
            });
          } else {
            $(this).parent().addClass("active");
            $(this).attr({
              "aria-expanded": "true",
              "aria-label": Drupal.t("Collapse notification"),
            });
          }
        }
      );
    }

    // desktopNav();
    toggleSearch();
    searchClear();
    searchInput();
    mapSection();
    toggleDmbNotification();

    enquire.register("screen and (max-width: 1199px)", {
      match: function () {
        mobileNav();
      },
      unmatch: function () {
        desktopNav();
        toggleSearch();
        searchInput();
      },
    });

    enquire.register("screen and (min-width: 1200px)", {
      match: function () {
        desktopNav();
        toggleSearch();
        searchInput();
      },
      unmatch: function () {
        mobileNav();
      },
    });
  });
})(jQuery, Drupal);

function copyCurrentUrl() {
  const currentUrl = window.location.href;

  navigator.clipboard
    .writeText(currentUrl)
    .then(() => {
      alert("URL copied: " + currentUrl);
    })
    .catch((err) => {
      console.error("Failed to copy URL: ", err);
      alert("Failed to copy URL. Please copy it manually.");
    });
}
